import { AuthAPI } from '@/api'
const jwt = require("jwt-simple");
import CONFIG from '@/config'
import { stat } from 'fs';

const state = {
  user: null,
  token: null,
  claims: null,
  firebaseLoaded: false,
  sessionLoaded: false
}


const actions = {
  async refreshToken({ dispatch, commit, state }) {
    let { data } = await AuthAPI.refreshToken(state.user.user.email, state.user.refreshToken);
    await dispatch('getUser', data.data);
  },
  async login({ dispatch, commit }, email, passwd) {
    let user = await AuthAPI.login(email, passwd);
    await dispatch('getUser', user);
  },
  async signOut({ dispatch, commit }, firebase) {
    if (CONFIG.USE_FIREBASE) {
      firebase.auth().signOut();
    } else {
      commit('logout');
    }
  },

  /**
   * firebase 의 인증 정보가 변경되었을 경우에 호출된다.
   * firebase sdk 에서 사용자를 가지고 온다.
   * @param {*} param0
   * @param {*} user
   */
  async getUser({ dispatch, commit }, user) {
    if (CONFIG.USE_FIREBASE) {
      // getUser 는 firebase 의 인증정보가 변경되었을 경우에 호출한다.
      commit('setFirebaseLoaded')
      // 로그인 사용자 정보를 설정한다.
      commit('setUser', user)
      if (!user) return null
      await dispatch('getToken')
    } else {
      commit('setFirebaseLoaded');
      // 로그인 사용자 정보를 설정한다.

      commit('setUser', user)
      if (!user) return null
      await dispatch('getToken')
    }
    return true
  },

  /**
   * update token.
   * @param {*} param0
   */
  async getToken({ commit, state }) {
    if (CONFIG.USE_FIREBASE) {
      const token = await state.user.getIdToken(true)
      if (!token) return null
      commit('setToken', token)
      const { claims } = await state.user.getIdTokenResult()
      commit('setClaims', claims)
    } else {
      const token = state.user.accessToken;
      const claims = jwt.decode(state.user.accessToken, CONFIG.JWT_SEC);
      commit('setToken', { 'token': state.user.accessToken, 'refreshToken': state.user.refreshToken });
      commit('setClaims', claims)
      console.log(claims)
    }
  },
  async objInfo({ commit, state }, objNm) {
    if (state.objCache) {
      state.objCache = [];
    };
    if (state.objCache[objNm]) {
      commit('objInfo', state.objCache[objNm]);
      return;
    }
    let obj = await ObjAPI.objInfo(objNm)
      .catch(e => {
        console.log("error", e);
      });
    state.objCache[objNm] = obj.data;
    commit('objInfo', obj.data);
  }
}

const mutations = {
  init(state) {
    if (CONFIG.USE_FIREBASE) {
      return;
    }
    if (sessionStorage.getItem('user')) {
      try {
        let user = JSON.parse(sessionStorage.getItem('user'));
        if (!user)
          return;
        try {
          const claims = jwt.decode(user.accessToken, CONFIG.JWT_SEC);
          state.claims = claims;
        } catch (error) {
          console.log(error);
          if (error.message == "Token expired") {

          }
          // return;
        }
        state.user = user;
        state.token = state.user.accessToken;

      } catch (er) {
        console.log("error", er);
      }
    } else {
      console.log('no user');
    }
  },
  setUser(state, user) {
    state.user = user;
    if (!CONFIG.USE_FIREBASE) {
      sessionStorage.setItem('user', JSON.stringify(user));
    }
  },
  setToken(state, { token, refreshToken }) {
    state.token = token
    state.rtoken = refreshToken
  },
  setClaims(state, claims) {
    state.claims = claims
  },
  setSessionLoaded(state) {
    state.sessionLoaded = true
  },
  setFirebaseLoaded(state) {
    state.firebaseLoaded = true
  },
  logout(state) {
    console.log("logout...")
    state.auth = null
    state.crud = null
    state.admin = null
    state.user = null
    sessionStorage.setItem('user', null);
  }
}
const getters = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.store.js